import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { Column } from "@xo-union/tk-component-grid";
import styles from "../../css/styles.css";

const FormColumn = props => /*#__PURE__*/React.createElement(Column, _extends({
  className: styles.col
}, props));

export default FormColumn;